/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-company-department .FormElement-static.truncated{overflow:hidden}app-company-department .Card-inner{padding-right:unset}.Island-general{display:block;padding-top:.8rem;padding-bottom:.5rem}.MultiCompanyOrganization{padding-top:.5rem}"];
export { styles as styles };
